import type { LeaderboardItem } from '../../store/game.store';

interface RightPanelProps {
  leaderboard: LeaderboardItem[];
  currentUser: string;
}

export function RightPanel({
  leaderboard,
  currentUser,
}: RightPanelProps) {
  return (
    <div className="glass rounded-3xl p-4 border border-white/10 shadow-glow-lg flex flex-col justify-start h-full text-left overflow-hidden">
      <div className="flex-1 flex flex-col overflow-hidden">
        {/* Active Players */}
        <div className="space-y-1.5 flex-1 flex flex-col overflow-hidden">
          <label className="text-[9px] font-bold uppercase tracking-wider text-surface-400 block mb-1">
            Active Players
          </label>
          <div className="space-y-1.5 overflow-y-auto pr-1 flex-1">
            {leaderboard.map((player) => {
              const isMe = player.name === currentUser;
              return (
                <div
                  key={player.name}
                  className={`flex items-center justify-between px-2.5 py-1.5 rounded-lg border text-[9px] font-bold uppercase tracking-wide ${
                    player.isOut
                      ? 'bg-red-950/15 border-red-500/10 text-surface-500 line-through'
                      : isMe
                        ? 'bg-purple-600/15 border-purple-500/30 text-purple-300 font-black'
                        : 'bg-slate-950/20 border-white/2 text-surface-300'
                  }`}
                >
                  <div className="flex items-center space-x-1.5">
                    <span className="truncate max-w-[120px]">{player.name}</span>
                    {player.isOut && (
                      <span className="text-[7px] bg-red-500/20 text-red-400 border border-red-500/20 px-1 rounded font-black tracking-widest lowercase">
                        out
                      </span>
                    )}
                  </div>
                  <span className="text-[9px] font-black font-mono text-purple-300">
                    {player.score} pts
                  </span>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
export default RightPanel;
